<template>
    <div class="component-container">
        <div class="deploy-label">Deploy New Prototype</div>

        <div class="vcore_input-group">
            <label class="vcore_input-label">Project File</label>
            <input
                    type="file"
                    name="file"
                    id="file"
                    class="file_input"
                    ref="file"
                    v-on:change="handleFileUpload()"
            />
            <!--<label for="file" class="file_input-label">Choose a file</label>-->
            <hr class="underline">
        </div>
        <span class="vcore_input-addon">Select a .zip file to upload.</span>
        <div class="vcore_row button-row">
            <div class="vcore_col--xs--12">
                <button
                        class="vcore_btn vcore_btn--primary md-button blue-button"
                        type="button"
                        @click="addNewDeploy"
                >New Deploy</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";

    export default {
        name: "EditPrototype",
        methods: {
            ...mapActions([
                "createDeploy"
            ]),
            handleFileUpload(){
                this.$store.commit("fileUpdate", this.$refs.file.files[0])
            },
            addNewDeploy() {
                if(this.file !== "" && this.file !== undefined){
                    this.$store.commit("updateUpdate", Date.now());
                    this.createDeploy(this.$route.params.path)
                        // eslint-disable-next-line no-unused-vars
                        .then(result => {
                            this.$store.dispatch('populatePrototype', this.$route.params.path);
                            this.$refs.file.value = "";
                            //window.alert("Prototype successfully added.");
                        })
                        .catch(error => {
                            window.alert("Prototype could not be added. " + error);
                        })
                } else {
                    window.alert("Please attach a file and try again.");
                }
            },
        },
        computed: {
            ...mapGetters([
                "prototype",
                "deployed",
                "deploys",
                "file"
            ])
        }
    }
</script>

<style scoped lang="scss">

    @media (min-width: 768px){
        .component-container {
            margin-right: 10px;
        }
    }

    .deploy-label{
        text-align: left;
        font-size: 24px;
        font-weight: 500;
        margin-top: 30px;
        margin-bottom: 20px;
        color: #666666;
    }

    .vcore_btn {
        float: right;
        margin-left: 5px;
    }

    .vcore_input-label {
        font-family: "Open Sans", sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 33px;
        float: left;
        color: $color_black;
    }

    .divider {
        font-family: "Open Sans", sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 28px;
        line-height: 38px;
        text-align: left;
        color: $color_gray-3;
        margin-top: 25px;
    }

    .vcore_input-addon {
        font-family: "Open Sans", sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 19px;
        //float: left;
        color: $color_gray-4;
    }

    .file_input {
        //visibility: hidden;
        width: 100%;
        line-height: 0;
    }

    .file_input-label {
        width: 150px;
        padding: 10px 20px;
        border-color: black;
        background-color: black;
        color: white;
    }

    .underline {
        position: relative;
        top: 3px;
    }

    .md-button {
        font-size: 16px;
        font-weight: 600;
        padding: 10px 30px;
        min-width: 150px;
    }

    .button-row {
        margin-top: 15px;
    }

</style>
